import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';
import type {Disposable, Environment} from 'relay-runtime';
import type {MutationInput} from './MutationTypes';
import type {
	ImportEconomicCustomersMutation,
	ImportEconomicCustomersMutation$data,
	ImportEconomicCustomersMutation$variables,
} from './__generated__/ImportEconomicCustomersMutation.graphql';

const mutation = graphql`
	mutation ImportEconomicCustomersMutation($input: ImportEconomicCustomersInput!) {
		importEconomicCustomers(input: $input) {
			unlinkedBillToCount
			company {
				clients(first: 10000) {
					edges {
						node {
							id
							name
							notes
							logoId
							logoDefaultId
							projectCount
							xeroContactId
						}
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<ImportEconomicCustomersMutation$variables['input']>,
	onSuccess?: (response: ImportEconomicCustomersMutation$data) => void,
	onError?: (error: Error) => void
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<ImportEconomicCustomersMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
